import React from 'react';
import { Layouts } from 'app-components';
import { FormattedMessage } from 'react-intl';

import { ResultsSection } from './ResultsSection';
import { TicketHeader } from './TicketHeader/TicketHeader';
import { SearchType } from './constants/ticketlist.constants';
import { AdvanceSearch } from './AdvanceSearch/AdvanceSearch';
import { DefaultSearch } from './DefaultSearch/DefaultSearch';
import { useTicketListContainer } from './useTicketListContainer';
import { ErrorModal } from '../../../components/errorModal/ErrorModal';
import NavBarContainer from '../../../containers/common/NavBarContainer';
import { ConditionalRendering } from '../../../components/common/conditional-rendering';
import { StyledTabWrapper, StyledTab, StyledContentCard } from './constants/ticketlist.styled';

export const TicketListContainer = () => {
    const {
        isAdvanceSearch,
        setSelectedSearchType,
        fetchDefaultTickets,
        tickets,
        searchCriteria,
        ticketsCount,
        pageSortInfo,
        setPageSortInfo,
        isInitialLoad,
        onClaimNewTicket,
        onAddNewTicket,
        workgroupOptions,
        onErrorModalClose,
        isErrorModalOpen,
        errorMessage,
        modalTitle,
        enableTicketSupport,
        viewTicketPermission,
    } = useTicketListContainer();

    return (
        <Layouts id="manage-tickets">
            <NavBarContainer navBarClass="ticket-mgmt-top-nav grid-col-12" />
            <TicketHeader
                fetchDefaultTickets={fetchDefaultTickets}
                ticketsCount={ticketsCount}
                onClaimNewTicket={onClaimNewTicket}
                onAddNewTicket={onAddNewTicket}
                workgroupOptions={workgroupOptions}
                enableTicketSupport={enableTicketSupport}
                viewTicketPermission={viewTicketPermission}
            />
            <StyledTabWrapper>
                <StyledTab
                    data-testid="search-my-ticket"
                    onClick={() => setSelectedSearchType(SearchType.DEFAULT)}
                    disabled={!isAdvanceSearch}
                >
                    <FormattedMessage id="ticketList.tab.searchMyTicket" />
                </StyledTab>
                <ConditionalRendering isTrue={viewTicketPermission}>
                    <StyledTab
                        data-testid="advance-search"
                        onClick={() => setSelectedSearchType(SearchType.ADVANCE)}
                        disabled={isAdvanceSearch}
                    >
                        <FormattedMessage id="ticketList.tab.advanceSearch" />
                    </StyledTab>
                </ConditionalRendering>
            </StyledTabWrapper>
            <StyledContentCard id="main-content" data-testid="main-content">
                <ConditionalRendering isTrue={!isAdvanceSearch}>
                    <DefaultSearch pageSortInfo={pageSortInfo} workgroupOptions={workgroupOptions} />
                </ConditionalRendering>
                <ConditionalRendering isTrue={isAdvanceSearch}>
                    <AdvanceSearch pageSortInfo={pageSortInfo} />
                </ConditionalRendering>
                <ResultsSection
                    tickets={tickets}
                    searchCriteria={searchCriteria}
                    ticketsCount={ticketsCount}
                    pageSortInfo={pageSortInfo}
                    setPageSortInfo={setPageSortInfo}
                    isInitialLoad={isInitialLoad}
                    workgroupOptions={workgroupOptions}
                    isAdvanceSearch={isAdvanceSearch}
                    viewTicketPermission={viewTicketPermission}
                />
            </StyledContentCard>
            <ConditionalRendering isTrue={isErrorModalOpen}>
                <ErrorModal onClose={onErrorModalClose} errorText={errorMessage} titleId={modalTitle} />
            </ConditionalRendering>
        </Layouts>
    );
};
